import isURL from "validator/es/lib/isURL";


export const checkUrl = (url) => {
    return isURL(`${url}`, {
        protocols: ['http', 'https'],
        require_protocol: true
    })
}
